import { Api } from './insightsTypes';

export const api = new Api({
  baseURL: window.location.origin,
  headers: {
    'X-CSRF-Token': (
      document.querySelector('[name=csrf-token]') as HTMLMetaElement
    )?.content,
  },
});
